import React from "react"

import { formatDate } from "../../utils/format-date-time"

const NameSection = ({ profile, style }) => {
  return (
    <div className={"candidate-text " + !!style ? style : ""}>
      <h1>
        {!!profile?.first_name
          ? profile?.first_name + " " + profile?.last_name
          : profile?.organization_name}
      </h1>
      <h5 className={"blue-text mb-4"}>
        {profile?.profile?.position || profile?.industry_name}
      </h5>
      <h5>
        {profile?.candidate?.current_address
          ? profile?.candidate?.current_address
          : profile?.contact?.address
          ? profile?.contact?.address +
            ", " +
            profile?.contact?.district_name +
            ", " +
            profile?.country_name
          : ""}
      </h5>
      <>
        <h5 className="mb-0">
          {`Last Edited: ${formatDate(
            profile?.last_edited || profile?.date_joined
          )}`}
        </h5>
      </>
    </div>
  )
}

export default NameSection
